export const transformSearchParameters = (from = null, to = null) => {
  const originData = {
    iataCode: from?.iataCode,
    name: from?.name,
    city: from?.city,
    cityCode: from?.cityCode,
    continent: from?.continent,
    continentCode: from?.continentCode,
    country: from?.country,
    countryCode: from?.countryCode,
  };
  const destinationData = {
    iataCode: to?.iataCode,
    name: to?.name,
    city: to?.city,
    cityCode: to?.cityCode,
    continent: to?.continent,
    continentCode: to?.continentCode,
    country: to?.country,
    countryCode: to?.countryCode,
  };

  return {
    origin: from ? originData : null,
    destination: to ? destinationData : null,
  };
};
